import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '@services/inventory/inventory.service';
import { LoadingService } from '@services/loading/loading.service';
import { SettingService } from '@services/setting/setting.service';
import { SharedService } from '@services/shared/shared.service';
import { environment } from 'environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss'],
})
export class AddVehicleComponent implements OnInit {
  public laddaLoading: boolean = false;
  public addVehicleForm: FormGroup = null;
  public attributesList: any[] = [];
  public imageUrl: any;
  public imageGroup: any[] = [];
  public loading: boolean = false;
  public setImageIndicator: any = 0;
  public editInventoryIndicator: boolean = true;
  public indicator: boolean = true;
  public getProductId: any;
  modalRef?: BsModalRef;
  public setIndex: any;
  public imageInfo: any;
  public env = environment.forntend_url;
  public baseUrl: string = environment.imgBaseUrl;
  public vehicleId: string = '';
  public submitBtn: boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    public settingsService: SettingService,
    public toastr: ToastrService,
    public inventoryService: InventoryService,
    public sharedService: SharedService,
    public router: Router,
    public loader: LoadingService,
    public activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const vehicleId = this.activatedRoute.snapshot.paramMap.get('vehicleId');

    if (vehicleId) {
      this.vehicleId = vehicleId;
    }

    this.addVehicleForm = this.formBuilder.group({
      vehicle_360_link: [''],
      location: ['', [Validators.required]],
      description: ['', []],
      attributes: this.formBuilder.array([]),
    });

    this.getAttributesList();

    if (this.vehicleId) {
      this.editInventoryData(this.vehicleId);
    }
  }

  getProfileImage(eve: Event, data: number) {
    if (eve.target['files'][0]['size'] > 5242880) {
      this.toastr.error('Image size should not be greater than 5MB');
    } else {
      this.setImageIndicator = data;
      if (this.setImageIndicator === 1) {
        for (let images of eve.target['files']) {
          let reader: FileReader = new FileReader();
          reader.readAsDataURL(images);
          reader.onload = (eve) => {
            this.imageUrl = eve.target.result;
            this.imageGroup.push({
              image: this.imageUrl,
              image_id: '',
            });
            this.toastr.success('Image upload successful');
          };
        }
      }
    }
  }

  get attributes() {
    return this.addVehicleForm.get('attributes') as FormArray;
  }

  get formData() {
    return this.addVehicleForm.controls;
  }

  /**
   * getting all listed attributes from system setting
   */

  getAttributesList() {
    let editInventoryIndicator = JSON.parse(
      localStorage.getItem('addInventoryIndicator')
    );
    this.loading = true;
    this.settingsService.getProductAttributeList().subscribe(
      (res) => {
        let data = res['data'];
        if (data && data.length) {
          this.indicator = true;
          this.attributesList = data.reverse();
          this.attributesList.forEach((attribue) => {
            if (attribue['field_name'] === 'vehicle_360_link') {
              attribue['field_name'] = 'Vehicle 360 link';
            }
            if (attribue['field_name'] === 'test_drive_video') {
              attribue['field_name'] = 'Test Drive Video';
            }
          });

          let getId = JSON.parse(
            localStorage.getItem('editInventoryProductId')
          );
          if (getId) return;
          if (!this.getProductId) {
            if (editInventoryIndicator === true) {
              for (let object of this.attributesList) {
                this.attributes.push(
                  this.formBuilder.group({
                    [object.field_name]: ['', [Validators.required]],
                  })
                );
              }
            }
          } else if (this.getProductId) {
            if (editInventoryIndicator === true) {
              for (let object of this.attributesList) {
                this.attributes.push(
                  this.formBuilder.group({
                    [object.field_name]: [''],
                  })
                );
              }
            }
          }
        }
        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        if (error.error.message == 'The incoming token has expired') {
          this.router.navigate(['/']);
        } else {
          this.toastr.warning(error.statusText);
        }
      }
    );
  }

  /**
   * Edit Inventory Details
   */

  editInventoryData(getId) {
    this.loading = true;
    this.editInventoryIndicator = JSON.parse(
      localStorage.getItem('addInventoryIndicator')
    );

    if (this.editInventoryIndicator) {
      this.inventoryService.getvehicleInfo(getId).subscribe(
        async (res) => {
          this.attributes.clear();
          this.indicator = false;
          let data = res['data'];
          this.getProductId = data['product_id'];
          for (let [key, object] of Object.entries(data['description_data'])) {
            this.attributes.push(
              this.formBuilder.group({
                [key]: [object],
              })
            );
          }

          let set_location = data['location'];
          this.addVehicleForm.get('location').setValue(set_location);

          // Set Images
          this.imageGroup = [];
          if (data['imageUrl'] && !data['vehicle_images']) {
            for (let value of data['imageUrl']) {
              this.imageGroup.push({
                image: value['presigned_url'],
                image_id: value['imageId'],
                image_name: value['media_name'],
              });
            }
          } else if (data['vehicle_images']) {
            for (let value of data['vehicle_images']['parts_images']) {
              this.imageGroup.push({
                image: this.baseUrl + value['image'],
                image_id: value['part_id'],
                image_name: value['part_name'],
              });
            }
          }

          this.loading = false;
        },
        (error: HttpErrorResponse) => {
          if (error.error.message == 'The incoming token has expired') {
            this.router.navigate(['/']);
          }
        }
      );
    }
  }

  /**
   *  Add product to list
   */

  addVehicle() {
    this.submitBtn = true;
    if (this.addVehicleForm.invalid) {
      this.toastr.error('Please Fill all feields');
      this.laddaLoading = false;
      return false;
    }

    this.addInventory(this.addVehicleForm.value);
  }

  /**
   *  sending data to api
   */

  addInventory(data: Record<any, any>) {
    if (data) {
      let dataObj: object = {};
      data.attributes.forEach((item, index) => {
        Object.entries(item).forEach(([key, value]) => {
          if (!dataObj.hasOwnProperty(key)) {
            dataObj = {
              ...dataObj,
              [key]: value,
            };
          }
        });
      });

      let value = JSON.stringify(dataObj)
        .replace(/[\{\}']+/g, '')
        .replace(/[\[\]']+/g, ''); // remove all brackets

      let final_value = '{' + value + '}';
      let product = {
        product: {
          product_id: this.vehicleId ? this.vehicleId : '',
          files: this.imageGroup,
          description_data: final_value,
          location: data['location'],
          type: 1,
        },
      };

      if (this.imageGroup && this.imageGroup.length < 1) {
        return this.toastr.error('Minimum 1 image require to add a Vehicle!');
      }

      this.laddaLoading = true;
      this.inventoryService.addvehicle(product).subscribe(
        (res) => {
          this.laddaLoading = false;
          this.toastr.success(res['message']);
          this.router.navigate([`/dashboard/inventory`], {
            queryParams: { type: 'vehicle' },
          });
        },
        (error: HttpErrorResponse) => {
          this.toastr.warning(error.statusText);
        }
      );
    }
  }

  /**
   * Open Image delete Modal
   */

  openModal(imageInfo: any, index: any) {
    this.setIndex = index;
    this.imageInfo = imageInfo;
  }

  /**
   * Delete inventory Image
   */

  deleteImage() {
    this.imageGroup.splice(this.setIndex, 1);

    if (this.imageInfo) {
      let getType = JSON.parse(localStorage.getItem('type'));

      let delete_info = {
        id: this.getProductId,
        image_name: this.imageInfo['image_name'],
        type: getType,
      };

      this.inventoryService.deleteProductImage(delete_info).subscribe(
        (res) => {
          this.toastr.success('Image Deleted');
          this.modalRef.hide();
        },
        (error: HttpErrorResponse) => {
          if (error.error.message == 'The incoming token has expired') {
            this.router.navigate(['/']);
          } else {
            this.toastr.warning(error.statusText);
          }
        }
      );
    }
  }

  deleteImageInfo(imageInfo: any, index: any) {
    this.setIndex = index;
    this.imageInfo = imageInfo;
  }

  public saveFile(fileName: string): void {}

  public handleDismiss(dismissMethod: string): void {}
}
